module.exports = __webpack_public_path__ + "static/media/politicas_icon_6.23d8988a.svg";